import { render, staticRenderFns } from "./LeaderboardComponent.vue?vue&type=template&id=00b76eca&"
import script from "./LeaderboardComponent.vue?vue&type=script&lang=js&"
export * from "./LeaderboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports